import React, { useEffect, useState } from "react";
import { mapArrayToObject } from "../../commonFunctions/arrayFunc";
import FilterApplicationBlocks from "../../components/BuilderComponents/FilterApplicationBlocks";
import { getElementConfig } from "../../components/BuilderComponents/JobConfigration/Utils";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import RightSideBar from "../../components/SideBar/RightSideBar";
import { AllFolderCollapse } from "../../components/SideBar/Tree";
import { useAppBlocksContext } from "../../context/AppBlocksContext";
import { useScreenContext } from "../../context/ScreenContext";
import { useTreeContext } from "../../context/TreeDataContext";
import BuilderTabs from "../../Layouts/BuilderTabs";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { getFieldIcon } from "../../utils/getFieldIcon";
import { convertGridToPixels, getMaxBottom, getOffset, getPositionedElementConfig } from "../FlexibleLayout/utils";
import AddNewBlockFromScreen from "./AddNewBlockFromScreen";
import { SCREEN_WIDTHS } from "../../constant/constant";
import { useTemplateContext } from "../../context/TemplateContext";
import fileFolderConfig from "../../commonFunctions/fileFolderConfig";

const ScreenElementsRightBar = ({
  allApplicationData,
  setDragFromOutside,
  setAllApplicationData,
  device,
  setDraggedItem,
  setDragOffset,
  isPositionScreen
}) => {
  const { selectedDevice, blocksExplorerData } = useTreeContext();
  const [selectedDeviceAppBlockTree, setSelectedDeviceAppBlockTree] = useState([]);
  const [applicationBlocks, setApplicationBlocks] = useState([]); // For application blocks tab
  const { allBlocksData } = useAppBlocksContext();
  const { checkedBlocks, setCheckedBlocks, currentScreenData } = useScreenContext();
  const [isBlockOpen, setIsBlockOpen] = useState(false);
  const { getReactComponents, reactComponent } = useTemplateContext();

  useEffect(() => {
    getReactComponents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createReactComponentsFolder = (reactComponents, device) => {
    if (!reactComponents || !Array.isArray(reactComponents) || reactComponents.length === 0) {
      return null;
    }

    const folder = fileFolderConfig.getFolderConfig(
      `${device}/custom-component`,
      "React Components",
      device,
      false,
      false,
      true,
      "",
      "",
      false,
      {}
    );

    // Create file items for each React component
    folder.items = reactComponents.map((component) =>
      fileFolderConfig.getFileConfig(
        component.id,
        component.name,
        `${device}/custom-component`,
        false, // can_delete
        false, // can_edit
        {}, // fileInfo
        "custom-component" // type
      )
    );

    return folder;
  };

  // const handleDragStart = (e, name, id, parentData) => {
  //   e.stopPropagation();
  //   const parentArray = parentData.split("/");
  //   const type = parentArray[parentArray.length - 1];
  //   const obj = { id: id, name: name, type };
  //   if (isPositionScreen) {
  //     let newConfig = getPositionedElementConfig(obj.type);
  //     if (type !== "block" && type !== "section" && type !== "column" && type !== "tabview") {
  //       newConfig.config = getElementConfig(obj);
  //     }
  //     const offset = getOffset(e);

  //     if (allApplicationData[id] && (type === "detailsview" || type === "recordsview" || type === "chart")) {
  //       const { is_positioned_block, position_block_config } = allApplicationData[id];
  //       if (is_positioned_block && position_block_config) {
  //         let newDVBlockConfig = position_block_config;
  //         if (parentArray[0] === "mobile") {
  //           newDVBlockConfig = convertGridToPixels(
  //             position_block_config || [],
  //             currentScreenData.position_screen_metadata?.grid_size
  //           );
  //         }
  //         const height = getMaxBottom(newDVBlockConfig);
  //         newConfig.style.height = `${height}px`;
  //         newConfig.style.width = parentArray[0] === "desktop" ? "1600px" : "512px";
  //       }
  //     }
  //     setDraggedItem(newConfig);
  //     setDragOffset(offset);
  //   } else {
  //     setDragFromOutside(true);
  //     if (e.nativeEvent instanceof DragEvent) {
  //       e.dataTransfer.setData("type", JSON.stringify(obj));
  //     }
  //   }
  // };

  const handleDragStart = (e, name, id, parentData) => {
    e.stopPropagation();

    const type = getTypeFromParentData(parentData);
    const obj = {
      id,
      name,
      type
    };
    const parentDevice = parentData.split("/")[0];

    if (isPositionScreen) {
      const { config } = preparePositionedConfig(obj, allApplicationData, currentScreenData, parentDevice, device);
      const offset = getOffset(e);
      setDraggedItem(config);
      setDragOffset(offset);
    } else {
      setDragFromOutside(true);
      if (e.nativeEvent instanceof DragEvent) {
        e.dataTransfer.setData("type", JSON.stringify(obj));
      }
    }
  };

  useEffect(() => {
    const filteredBlocks = getFilteredDeviceTreeBlocks(blocksExplorerData, device);
    const finalAppData = generateBlockTreeMap(allBlocksData);
    const customComponentsFolder = createReactComponentsFolder(reactComponent, device);
    const mergedBlocks = customComponentsFolder ? [...filteredBlocks, customComponentsFolder] : filteredBlocks;
    setSelectedDeviceAppBlockTree(mergedBlocks);
    setAllApplicationData(finalAppData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reactComponent, blocksExplorerData, device, allBlocksData]);

  useEffect(() => {
    if (!selectedDeviceAppBlockTree.length) return;
    const filteredItems = filterBlocksByFileInfo(selectedDeviceAppBlockTree, checkedBlocks);
    setApplicationBlocks(filteredItems);
  }, [checkedBlocks, selectedDeviceAppBlockTree, selectedDevice]);

  const tabData = [
    {
      label: "Blocks",
      content: <BasicElements onDragStart={handleDragStart} isPositionScreen={isPositionScreen} />
    },
    {
      label: "Application Blocks",
      content: (
        <>
          <div className="sidebar_top_header">
            <div>Filters</div>
            <div className="d_flex align_center justify_end gap_2 w_100">
              <AllFolderCollapse explorerData={applicationBlocks} setExplorerData={setApplicationBlocks} />
              <MaterialIcon name="add" className="cursor_pointer" onClick={() => setIsBlockOpen(true)} />
              <FilterApplicationBlocks checkedBlocks={checkedBlocks} setCheckedBlocks={setCheckedBlocks} />
            </div>
          </div>

          <RightSideBar
            explorerData={applicationBlocks}
            setExplorerData={setApplicationBlocks}
            handleDragStart={handleDragStart}
            actionNeeded={false}
          />
        </>
      )
    }
  ];

  return (
    <div className="screen_right_element">
      <BuilderTabs tabs={tabData} containerClass="form_field" />
      <BuilderModal isOpen={isBlockOpen} onClose={() => setIsBlockOpen(false)} modalName={`Add Block`}>
        <AddNewBlockFromScreen onClose={() => setIsBlockOpen(false)} />
      </BuilderModal>
    </div>
  );
};
const componentConfigs = [
  { id: "section", name: "Section" },
  { id: "column", name: "Column" },
  { id: "block", name: "Block" },
  { id: "button", name: "Button" },
  { id: "html", name: "HTML" },
  { id: "image", name: "Image" },
  { id: "label", name: "Label" },
  { id: "spacer", name: "Spacer" },
  { id: "tabview", name: "Tabview" },
  { id: "form", name: "Form" },
  { id: "button-group", name: "Button Group" },
  { id: "dropdown-navigate", name: "Dropdown Navigate" },
  { id: "separator", name: "Separator" },
  { id: "file_viewer", name: "File Viewer" },
  { id: "icon", name: "Icon" },
  { id: "dv-group", name: "DV group" }
];
const BasicElements = ({ onDragStart, isPositionScreen = true }) => {
  const componentFolder = componentConfigs.filter((config) => {
    if (isPositionScreen) {
      return true;
    }
    return !["section", "column", "block"].includes(config.key);
  });
  return (
    <div className="blocks">
      <div style={{ gridTemplateColumns: "repeat(2, 1fr)", gap: "12px" }} className="d_grid">
        {componentFolder?.map((block) => (
          <div
            key={block.id}
            className="draggable_input_field d_inline_block"
            onClick={() => {}}
            onDragStart={(e) => onDragStart(e, block.name, block.id, block.id, block)}
            draggable={true}
            style={{ width: "100%" }}
          >
            <div className="flex_column align_center">
              <MaterialIcon
                name={getFieldIcon(block.id || block.parentData)}
                style={{ fontSize: "24px", marginBottom: "4px" }}
              />
              <span title={block.name} className="field_name" style={{ textAlign: "center" }}>
                {block.name}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const filterBlocksByFileInfo = (appsBlocks, checkedBlocks) => {
  if (!checkedBlocks.table.length && !checkedBlocks.tag.length && !checkedBlocks.appUser && !checkedBlocks.rdbms) {
    return appsBlocks;
  }

  return appsBlocks.reduce((result, block) => {
    const filteredItems = block.items.filter((item) => {
      const tags = item.fileInfo?.info_tag || [];
      const tableId = item.fileInfo?.table_id || "";
      const isAppUserBlock = item.fileInfo?.table_id === "appuser";
      const isRdbmsBlock = item.type === "rdbms";

      const hasTags = tags.some((tag) => checkedBlocks.tag.includes(tag));
      const hasTableId = checkedBlocks.table.includes(tableId);

      if (checkedBlocks.appUser) {
        return isAppUserBlock && (hasTags || hasTableId || (!checkedBlocks.tag.length && !checkedBlocks.table.length));
      } else if (checkedBlocks.rdbms) {
        return isRdbmsBlock && (hasTags || hasTableId || (!checkedBlocks.tag.length && !checkedBlocks.table.length));
      } else {
        return (
          !isAppUserBlock &&
          !isRdbmsBlock &&
          (hasTags || hasTableId || (!checkedBlocks.tag.length && !checkedBlocks.table.length))
        );
      }
    });

    if (filteredItems.length) {
      result.push({ ...block, items: filteredItems });
    }

    return result;
  }, []);
};

const EXCLUDED_TREE_BLOCK_TYPES = ["progress-bar", "activitycard"];

const getFilteredDeviceTreeBlocks = (blocksExplorerData, device) => {
  const selectedDeviceBlocks = blocksExplorerData.find((block) => block.id === device)?.items || [];

  return selectedDeviceBlocks.filter((block) => {
    const blockType = block.id.split("/")[1];
    return !EXCLUDED_TREE_BLOCK_TYPES.includes(blockType);
  });
};

const generateBlockTreeMap = (allBlocksData) => {
  return allBlocksData.reduce((acc, blockData) => {
    Object.values(blockData.data).forEach((blockArray) => {
      const { result: mapped } = mapArrayToObject(blockArray || []);
      Object.assign(acc, mapped);
    });
    return acc;
  }, {});
};

const getTypeFromParentData = (parentData) => {
  const parentArray = parentData.split("/");
  return parentArray[parentArray.length - 1];
};

const preparePositionedConfig = (obj, allApplicationData, currentScreenData, parentDevice, device) => {
  let newConfig = getPositionedElementConfig(obj.type, device);

  if (!["block", "section", "column", "tabview"].includes(obj.type)) {
    newConfig.config = getElementConfig(obj);
  }

  const data = allApplicationData[obj.id];
  if (data && ["detailsview", "recordsview", "chart"].includes(obj.type)) {
    const { is_positioned_block, position_block_config } = data;
    if (is_positioned_block && position_block_config) {
      let newDVBlockConfig = position_block_config;
      if (parentDevice === "mobile") {
        newDVBlockConfig = convertGridToPixels(
          position_block_config,
          currentScreenData.position_screen_metadata?.grid_size
        );
      }
      const height = getMaxBottom(newDVBlockConfig);
      newConfig.style.height = `${height}px`;
      newConfig.style.width = SCREEN_WIDTHS[parentDevice];
    }
  }

  return { config: newConfig };
};

export default ScreenElementsRightBar;
